<template>
  <div>
    <headerBox :current="8"></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div class="content_box">
      <div class="search_box">
        <div>
          单位名称：<Input
            v-model="params.dwmc"
            placeholder=""
            style="width: 180px"
          ></Input>
        </div>
        <!--        <div>-->
        <!--          年度：<Input-->
        <!--            v-model="params.sbnd"-->
        <!--            placeholder=""-->
        <!--            style="width: 180px"-->
        <!--          ></Input>-->
        <!--        </div>-->
        <!--        <div>-->
        <!--          信用等级：<Input-->
        <!--            v-model="params.xyjb"-->
        <!--            placeholder=""-->
        <!--            style="width: 180px"-->
        <!--          ></Input>-->
        <!--        </div>-->
        <div class="btn1" @click="toSearch">查询</div>
        <div class="btn2" @click="toReset">重置</div>
      </div>
      <div class="box1">
        <el-table
          :cell-style="{ lineHeight: '40px', height: '40px', padding: 0 }"
          :data="tableData"
          :header-cell-style="{
            lineHeight: '40px',
            height: '40px',
            padding: 0,
            backgroundColor: '#49b3ff',
            color: '#515a6e',
          }"
          stripe
          style="width: 100%"
        >
          <el-table-column align="center" label="序号" type="index" width="80">
          </el-table-column>
          <el-table-column
            align="center"
            label="单位名称"
            prop="dwmc"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            :label="String($moment().subtract(3, 'years').year())"
            :prop="`year${$moment().subtract(3, 'years').year()}`"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="
                  rowClick(scope.row, $moment().subtract(3, 'years').year(), 1)
                "
                >{{
                  scope.row[`year${$moment().subtract(3, "years").year()}`]
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            :label="String($moment().subtract(2, 'years').year())"
            :prop="`year${$moment().subtract(2, 'years').year()}`"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="
                  rowClick(scope.row, $moment().subtract(2, 'years').year(), 2)
                "
                >{{
                  scope.row[`year${$moment().subtract(2, "years").year()}`]
                }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            :label="String($moment().subtract(1, 'years').year())"
            :prop="`year${$moment().subtract(1, 'years').year()}`"
            align="center"
            show-overflow-tooltip
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="
                  rowClick(scope.row, $moment().subtract(1, 'years').year(), 2)
                "
                >{{
                  scope.row[`year${$moment().subtract(1, "years").year()}`]
                }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Page
        v-if="tableData.length != 0"
        :current="params.pageNo"
        :page-size="params.pageSize"
        :total="total"
        class="common_page_box"
        show-total
        @on-change="changePage"
      ></Page>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import { gSDeclareRecordApi } from "@/api/home/guild";

export default {
  name: "home",
  components: {
    bannerBox,
    headerBox,
    footerBox,
  },
  data() {
    return {
      xyInfo: {},
      isPdf: false,
      th: ["序号", "单位名称", "年度", "信用等级"],
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
        dwmc: "",
        sbnd: "",
        xyjb: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.params.dwmc = this.$route.query.dwmc;
    this.$refs["bannerChild"].locationList = ["行业信用", "信用评价"];
    const savedPage = sessionStorage.getItem("newsPage");
    if (savedPage && JSON.parse(savedPage).catid == "industryCredit") {
      this.params = JSON.parse(savedPage);
      this.getList();
    } else {
      this.getList(); //信用评价
    }
  },
  methods: {
    /* ====================数据请求部分========================== */
    toSearch() {
      this.params.pageNo = 1;
      this.getList();
    },
    toReset() {
      this.params.dwmc = "";
      this.params.sbnd = "";
      this.params.xyjb = "";
      this.params.pageNo = 1;
      this.getList();
    },
    getList() {
      gSDeclareRecordApi(this.params).then((res) => {
        if (res.code == 200 || res.code == 0) {
          console.log("res", res);
          this.tableData = res.result.records || [];
          this.total = res.result.total;
        }
      });
    },
    changePage(e) {
      this.params.pageNo = e;
      this.getList();
    },
    rowClick(row, year, type) {
      // 使用动态属性名获取对应年份的数据
      const yearData = row[`year${year}`];

      // 如果对应年份的数据为 "/"，则不执行跳转
      if (yearData === "/") {
        return;
      }

      this.$router.push({
        path: "industryCreditDetails",
        query: {
          dwId: row.dwId,
          year: year,
        },
      });
      sessionStorage.setItem(
        "newsPage",
        JSON.stringify({
          ...this.params,
          catid: "industryCredit",
        }),
      );
      console.log("row, column, event", row, year, type);
    },
  },
};
</script>

<style lang="scss">
.content_box {
  font-size: 15px;
  margin: 80px 200px;
  min-height: 350px;

  .search_box {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;

    > div {
      margin: 10px;
      white-space: nowrap;
      cursor: pointer;
    }

    .btn1 {
      background: linear-gradient(270deg, #2d85e2 2%, #5b43df 100%);
      color: #fff;
      padding: 5px 15px;
    }

    .btn2 {
      background: #767676;
      color: #fff;
      padding: 5px 15px;
    }
  }

  .box1 {
    min-height: 350px;

    /deep/ {
      .el-table__header-wrapper {
        .el-table__body {
          .el-table__row:hover {
            background: red;
          }
        }
      }
    }
  }

  .title {
    font-size: 22px;
    text-align: center;
  }

  .line_box {
    padding: 50px 0 5px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .time {
      font-size: 12px;
    }

    .share {
      display: flex;

      img {
        height: 25px;
        margin: 0 10px;
        cursor: pointer;
      }

      .qrcode {
        height: 100px;
      }
    }
  }
}

.cell_box {
  margin-top: 20px;

  .cell {
    display: flex;
    width: 100%;
    white-space: nowrap;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;

    > div {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > div:first-child {
      width: 15%;
    }

    > div:nth-child(2) {
      width: 50%;
    }

    > div:nth-child(3) {
      width: 20%;
    }

    > div:nth-child(4) {
      width: 15%;
    }
  }

  .th {
    background-color: #49b3ff;
  }

  .td:nth-child(odd) {
    background-color: #d8d8d8;
  }
}
</style>
